import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function SocialCallback() {
  let navigate = useNavigate();
  let [params] = useSearchParams();
  let platform = params.get('platform') || '';
  let status = params.get('status') || '';

  useEffect(() => {
    if (status == 'success')
      navigate('/creator/profile?connected=' + platform, {replace: true});
    else
      navigate('/creator/profile?connect_err=' + platform, {replace: true});
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="inline-block w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}